import { useMemo } from "react";
import { useRecords } from "../../../api/useRecords";
import { VACATION_LIVE_START_DATE } from "./holidaysSummary";

type UserHolidayBuckets = {
    thisYear: Array<any>;
    priorYears: Array<any>;
};

export const useHolidayHistoryByUser = (selectedYear: number) => {
    const { data: holidayHistory } = useRecords("time_off", "user.id,start_date,end_date,type", {
        extraOptions: {
            filter: {
                _and: [
                    { type: { _eq: "holiday" } },
                    { start_date: { _gte: VACATION_LIVE_START_DATE } },
                    { start_date: { _lt: `${selectedYear + 1}-01-01` } },
                ],
            },
            pageSize: -1,
        },
    });

    const holidayHistoryByUser = useMemo(() => {
        const map = new Map<string, UserHolidayBuckets>();
        (holidayHistory?.items || []).forEach((entry: any) => {
            const userIdForEntry = entry.user?.id;
            if (!userIdForEntry) return;
            if (!map.has(userIdForEntry)) {
                map.set(userIdForEntry, { thisYear: [], priorYears: [] });
            }
            const bucket = map.get(userIdForEntry)!;
            const isThisYear = entry.start_date >= `${selectedYear}-01-01`;
            if (isThisYear) {
                bucket.thisYear.push(entry);
            } else {
                bucket.priorYears.push(entry);
            }
        });
        return map;
    }, [holidayHistory, selectedYear]);

    return holidayHistoryByUser;
};
